module.exports = __webpack_public_path__ + "static/img/szafa_42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_42.svg
// module id = 4ySj
// module chunks = 0